import { createFileRoute, Outlet } from "@tanstack/react-router";
import { TopBarLayout } from "../components/TopBarLayout";

export const Route = createFileRoute("/_app")({
	component: () => (
		<TopBarLayout>
			<Outlet />
		</TopBarLayout>
	),
});
